import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { Alert, Button, Modal } from '@amzn/awsui-components-react';

export interface CancelModalProps {
    isCancelModalVisible: boolean;
    setIsCancelModalVisible: Dispatch<SetStateAction<boolean>>;
    isSubmitting?: boolean;
    onCancelConfirm: () => void;
    testPrefix: string;
    /** When false, bypasses the modal and navigates directly. Defaults to true. */
    isDirty?: boolean;
}
const CancelModal = ({
    isCancelModalVisible,
    setIsCancelModalVisible,
    isSubmitting,
    onCancelConfirm,
    testPrefix,
    isDirty = true,
}: CancelModalProps) => {
    useEffect(() => {
        if (isCancelModalVisible && !isDirty) {
            setIsCancelModalVisible(false);
            onCancelConfirm();
        }
    }, [
        isCancelModalVisible,
        isDirty,
        setIsCancelModalVisible,
        onCancelConfirm,
    ]);

    return (
        <Modal
            data-testid={`${testPrefix}-CancelModal`}
            visible={isCancelModalVisible}
            header="Discard changes?"
            footer={
                <span className="awsui-util-f-r">
                    <Button
                        data-testid={`${testPrefix}-CancelModalDiscardBtn`}
                        variant="link"
                        disabled={!!isSubmitting}
                        onClick={() => {
                            onCancelConfirm();
                        }}
                    >
                        Discard changes
                    </Button>
                    <Button
                        data-testid={`${testPrefix}-CancelModalKeepChangesBtn`}
                        variant="primary"
                        disabled={!!isSubmitting}
                        onClick={() => {
                            setIsCancelModalVisible(false);
                        }}
                    >
                        Keep changes
                    </Button>
                </span>
            }
            onDismiss={() => {
                setIsCancelModalVisible(false);
            }}
        >
            <Alert type="warning">
                Any changes made will not be saved. Do you want to proceed?
            </Alert>
        </Modal>
    );
};

export default CancelModal;
